import couponQueries from '@apis/queries/couponQueries';
import notificationQueries from '@apis/queries/notificationQueries';
import orderLogQueries from '@apis/queries/orderLogQueries';
import orderQueries from '@apis/queries/orderQueries';
import stampQueries from '@apis/queries/stampQueries';
import userQueries from '@apis/queries/userQueries';
import useOnPushMessageReceived from '@hooks/native/useOnPushMessageReceived';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@stackflow/react';
import { useQueryClient } from '@tanstack/react-query';
import { openExternalLink } from '@utils/nativeUtils';
import { useTranslation } from 'react-i18next';

function usePushMessage() {
    const { push } = useFlow();
    const queryClient = useQueryClient();
    const toast = useToast();
    const { t } = useTranslation('main', { keyPrefix: 'toast' });
    // 푸시 메시지 수신 리스너
    useOnPushMessageReceived({
        onPushMessageReceived: (data) => {
            queryClient.invalidateQueries({ queryKey: userQueries._def });
            queryClient.invalidateQueries({ queryKey: notificationQueries._def });
            queryClient.invalidateQueries({ queryKey: orderQueries._def });
            queryClient.invalidateQueries({ queryKey: couponQueries._def });
            queryClient.invalidateQueries({ queryKey: stampQueries._def });
            queryClient.invalidateQueries({ queryKey: orderLogQueries._def });

            const { pushType, pushArg, appState } = data;
            if (appState === 'BACKGROUND') {
                switch (pushType) {
                case 'NOTICE':
                    if (pushArg) {
                        push('NoticeActivity', { noticeId: pushArg });
                    }
                    return;
                case 'EVENT':
                    if (pushArg) {
                        push('EventActivity', { eventId: pushArg });
                    }
                    return;
                case 'COUPON':
                    push('CouponActivity', { type: 'DOWNLOAD' });
                    break;
                case 'URL':
                    if (pushArg) {
                        openExternalLink(pushArg);
                    }
                    break;
                default:
                    break;
                }
            } else {
                toast.info(t('newNotification'));
            }
        },
        deps: [t],
    });
}

export default usePushMessage;
